<div class="flex item-container">
	<ng-container *ngFor="let asset of assets">
		<div
			class="variation-item"
			[class.selected]="selectedAssetId && selectedAssetId === asset.id"
			(click)="setActiveAsset.emit(asset)"
		>
			<!-- Video variation -->
			<ng-container *ngIf="isVideo(asset); else imageTemplate">
				<video
					[src]="asset.assetPath"
					[poster]="getVideoThumbnail(asset)"
					muted
					loop
					playsinline
					(mouseenter)="$event.target.play()"
					(mouseleave)="$event.target.pause(); $event.target.currentTime = 0"
				></video>
				<mat-icon class="video-indicator">play_circle</mat-icon>
			</ng-container>

			<!-- Image variation -->
			<ng-template #imageTemplate>
				<img [src]="asset.assetPath" [alt]="asset.title || 'Variation'">
			</ng-template>

			<!-- Selection indicator -->
			<mat-icon *ngIf="selectedAssetId && selectedAssetId === asset.id" class="selected-indicator">check_circle</mat-icon>
		</div>
	</ng-container>
</div>
